import { getServer } from "@/Utlis/connections/aplication/getServer"
import { ConnectionRepository } from "@/Utlis/connections/infraestructure/ConnectionRepository"

export function SubscriptionRepository() {
    return {
        getSubscriptions,
        getSubscriptionsV6
    }
}

const connect = ConnectionRepository()

async function getSubscriptions() {
    try {
        const subs = await getServer(connect, 'v5/public/subscription')
        return subs.data
    } catch (error) {
        console.error(`Error in SubscriptionRepository Method getSubscriptions: ${error}`);
        return null
    }
}

async function getSubscriptionsV6(euro = false) {
    try {
        const subs = await getServer(connect, `v6/public/subscription/${euro}`)
        return subs.data
    } catch (error) {
        console.error(`Error in SubscriptionRepository Method getSubscriptions: ${error}`);
        return null
    }
}